export default {
  paymentPlans: []
}
